/**
 * Requestly: Intercept & Modify HTTP Requests
 *
 * Declares exactly one web-accessible resource — resources/images/128x128.png — matched
 * to <all_urls> with no `use_dynamic_url`. That single icon is fetchable at a fixed URL
 * from any page, which is enough to identify the extension conclusively.
 *
 * Being an image, it loads through probeImage with no CORS grant, so it survives a strict
 * page CSP. There is no second WAR to corroborate with, so this is a single-signal module.
 *
 * Manifest verified against version 26.6.10.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'mdnleldcmiljblolnjhpnblkcekpdkpa';

export const requestly: ExtensionDefinition = {
  id: ID,
  name: 'Requestly: Intercept & Modify HTTP Requests',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 300_000,
  notes:
    'Only one WAR — the 128x128 icon — exposed to every origin with no dynamic URL. ' +
    'A single <img> load is conclusive and needs no CORS grant.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load resources/images/128x128.png via <img> — the sole web-accessible resource, ' +
        'exposed to every origin and readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'resources/images/128x128.png'),
    },
  ],
};
